<div class="row background-image">
<div class="container">
    <div id="loginbox" style="margin-top:30px;margin-left: auto;margin-right: auto;" class="mainbox col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">

        <div class="row">
            <div class="col-md-2 col-md-offset-4" style="margin-left: 34%;">
                <img src="assets/images/logo.png" style="margin-left: -21px; margin-bottom: 10px;width:200px;height:50px;">

            </div>
        </div>

        <div class="card " >
            <div class="card-header bg-info">
                <div class="card-title" style="text-align:center; font-size: 17px; color: white;">Evolvtax Services Pvt Ltd</div>
            </div>

            <div style="padding-top:30px" class="card-body">

                <div style="display:none" id="login-alert" class="alert alert-danger col-sm-12"></div>

                <form  class="form-horizontal">
                    <div class="form-group" style="margin-bottom: 25px">   
                        <input type="text" class="form-control" id="username" name="username"
                             [(ngModel)]="username" placeholder="user name">
                    </div>

                    <div class="form-group" style="margin-bottom: 25px">   
                        <input type="password" class="form-control" id="password" name="password"
                             [(ngModel)]="password" placeholder="Password">
                             
                    </div>
                    
                    <!-- <div style="margin-bottom: 25px" class="input-group">
                        <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
                        <input id="password" type="password" [(ngModel)]="password" class="form-control" name="password"
                            placeholder="password">
                    </div> -->
 
                    <div style="margin-bottom: 25px" class="form-group">
                        <!-- <span class="input-group-addon"><i class="glyphicon glyphicon-th-large"></i></span> -->
                        <select name="userType" [(ngModel)]="role" id="userType" class="form-control" required placeholder="d.ff">
                            <!-- <option value="">---------User Type---------</option> -->
                            <option [ngValue]="undefined" hidden>---------User Type---------</option>
                            <option [value]="a.roleName" *ngFor="let a of dropdown">{{a.roleName}}</option>
                        </select>
                    </div>
                    <span id="type_error" class="errMsg"></span>
                    <div style="margin-top:10px" class="form-group">
                        <!-- Button -->
                        <div class="col-sm-12 controls" style="text-align: center;">
                            <input type="submit" (click)="login()" class="btn btn-success" value="Login" />
                        </div>
                        <span id="succMsg" class="succMsg"></span>
                        <span id="errMsg" class="errMsg"></span>
                    </div>
                    <div class="form-group">
                        <div class="col-md-12 control">
                            <div style="border-top: 1px solid#888; padding-top:15px; font-size:85%">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</div>